import axios from "axios";
import { useMemo, useState } from "react";



interface api {
    loading: boolean;
    error: boolean;
    data: string | object | any;
}

const getChainData = async () => {
    try {
        const { data } = await axios.get(
            process.env.REACT_APP_API_URL + "/topChain?duration=day"
        )
        const txCount = data?.data?.find((item: any) => item?.blockchainId === 'polygon')?.transactionCount

        return {
            txCount

        }
    }
    catch (error) {
        return error;
    }
}

export function useTxChainData() {
    const [api, setAPIData] = useState<api>({
        loading: true,
        error: false,
        data: "",
    });



    useMemo(async () => {
        const data = await getChainData();
        setAPIData({
            loading: false,
            error: false,
            data: data
        })
    }, [])
    return api;
}
